import * as service from './services'
import to from 'await-to-js'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async getTiposRegistro ({getters}, q) {
    const [error, response = { data: [] }] = await to(service.getTiposRegistro(q))
    if (error) {
      throw error
    }
    return response.data
  },
  async saveTipoRegistro (context, tipoRegistro) {
    context.dispatch('setLoading', true)
    const [error, response = { data: [] }] = await to(service.persist(tipoRegistro))
    if (error) {
      context.dispatch('setLoading', false)
      throw error
    }

    context.dispatch('setLoading', false)
    return response.data
  },
  async removeTipoRegistro (context, tipoRegistro) {
    context.dispatch('setLoading', true)
    const [error, response = { data: [] }] = await to(service.remove(tipoRegistro))
    if (error) {
      context.dispatch('setLoading', false)
      throw error
    }

    context.dispatch('setLoading', false)
    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/tipoRegistro/index.js